module.exports = __webpack_public_path__ + "zilla-slab-latin-600italic.4505df01a33e8f4f51594df704a31c2d.woff";